<template>
  <Avatar
    v-tooltip.bottom="{
      value: tooltipText,
      pt: { text: '!whitespace-pre-line' },
    }"
    :label="label"
    shape="circle"
    class="user-avatar"
    :class="{ 'cursor-pointer': clickable }"
    :style="{ backgroundColor: bgColor }"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Avatar from 'primevue/avatar';

const props = defineProps<{
  email: string | undefined | null;
  displayName?: string | null;
  orgName?: string | null;
  clickable?: boolean;
}>();

const PALETTE = [
  '#0ea5e9',
  '#22c55e',
  '#f59e0b',
  '#ef4444',
  '#a855f7',
  '#ec4899',
  '#14b8a6',
  '#6366f1',
];

const label = computed(() => {
  const name = props.displayName?.trim();
  if (name) {
    const initials = name
      .split(/\s+/)
      .map(part => part.charAt(0))
      .join('')
      .toUpperCase();
    return initials.slice(0, 2);
  }
  return (props.email?.trim()[0] || '?').toUpperCase();
});

const bgColor = computed(() => {
  const email = props.email;
  if (!email) return '#64748b';
  let h = 0;
  for (let i = 0; i < email.length; i++) {
    h = (h * 31 + email.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(h) % PALETTE.length];
});

const tooltipText = computed(() => {
  const lines = [props.displayName, props.email, props.orgName].filter(
    (line): line is string => !!line,
  );
  return lines.join('\n');
});
</script>

<style scoped>
.user-avatar {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.7rem;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
}
</style>
